import { ReactElement, ReactNode, Suspense } from 'react';
import Loader from './Loader';

interface IPageLoaderderProps {
  children: JSX.Element | ReactElement | ReactNode;
}

function PageLoader({ children }: IPageLoaderderProps) {

  return (
    <Suspense
      fallback={
        <div className="h-screen flex items-center justify-center">
            <Loader brollyLoaderFixed/>
        </div>
      }>
      {children}
    </Suspense>
  );
}

export default PageLoader;
